(function($, Drupal) {
  Drupal.behaviors.bokaYoutubeEpisodes = {
    attach(context) {
      once(
        "bokaYoutubeEpisodes",
        ".paragraph--type--youtube-episodes .block",
        context
      ).forEach(block => {
        const classBlurred = "blurred";
        const classBefore = "before";
        const classAfter = "after";
        if (block.querySelectorAll(".item").length) {
          // Clone each node to make them five.
          const items = block.querySelectorAll(".item");
          const itemsCount = 5;
          while (block.querySelectorAll(".item").length < itemsCount) {
            items.forEach(item => {
              if (block.querySelectorAll(".item").length < itemsCount) {
                block.appendChild(item.cloneNode(true));
              }
            });
          }
        }

        const items = block.querySelectorAll(".item");
        let active = 2;
        function loadShow() {
          const tX = [0, 90, 240, 360];
          const zIndex = 50;
          items[active].style.transform = `none`;
          items[active].style.zIndex = zIndex;
          items[active].style.filter = "none";
          items[active].style.opacity = 1;
          items[active].classList.remove(classAfter);
          items[active].classList.remove(classBefore);
          items[active].classList.remove(classBlurred);
          // show after
          let stt = 0;
          const scaleRatio = 0.25;
          for (let i = active + 1; i < items.length; i++) {
            stt += 1;
            items[i].style.transform = `translateX(${tX[stt]}px) scale(${1 -
              scaleRatio * stt}) perspective(${42 - 8 * stt}px) rotateY(-1deg)`;
            items[i].style.zIndex = zIndex - stt;
            items[i].style.filter = "blur(5px)";
            items[i].style.opacity = stt > 2 ? 0 : 0.6;
            items[i].classList.remove(classBefore);
            items[i].classList.add(classAfter);
            items[i].classList.add(classBlurred);
          }
          stt = 0;
          for (let i = active - 1; i >= 0; i--) {
            stt += 1;
            items[i].style.transform = `translateX(-${tX[stt]}px) scale(${1 -
              scaleRatio * stt}) perspective(${42 - 8 * stt}px) rotateY(1deg)`;
            items[i].style.zIndex = zIndex - stt;
            items[i].style.filter = "blur(5px)";
            items[i].style.opacity = stt > 2 ? 0 : 0.6;
            items[i].classList.remove(classAfter);
            items[i].classList.add(classBefore);
            items[i].classList.add(classBlurred);
          }
        }
        loadShow();
        const next = document.getElementById("next");
        const prev = document.getElementById("prev");
        next.onclick = function() {
          active = active + 1 < items.length ? active + 1 : active;
          loadShow();
        };
        prev.onclick = function() {
          active = active - 1 >= 0 ? active - 1 : active;
          loadShow();
        };
        items.forEach(item => {
          item.onclick = function() {
            if (!item.classList.contains(classBlurred)) {
              return;
            }
            if (item.classList.contains(classAfter)) {
              active = active + 1 < items.length ? active + 1 : active;
              loadShow();
            }
            if (item.classList.contains(classBefore)) {
              active = active - 1 >= 0 ? active - 1 : active;
              loadShow();
            }
          };
        });
      });
    }
  };
})(jQuery, Drupal);
